module.exports = __webpack_public_path__ + "media/flags/015-china-6a686ea5.svg";